import React, { useEffect } from "react";
import "./projects.css";
import ProjectShowcase from "../project-showcase/project-showcase";

import fileFreakImg from "../../assets/screenshots/FileFreak/FileFreak.io.png";
import fileFreakImg1 from "../../assets/screenshots/FileFreak/FileFreak_1.png";
import fileFreakImg2 from "../../assets/screenshots/FileFreak/FileFreak_2.png";
import fileFreakImg3 from "../../assets/screenshots/FileFreak/FileFreak_3.png";
import fileFreakImg4 from "../../assets/screenshots/FileFreak/FileFreak_4.png";

import fourSeasonsImg from "../../assets/screenshots/4SeasonsWharton/4SeasonsWharton.png";
import fourSeasonsImg1 from "../../assets/screenshots/4SeasonsWharton/4SeasonsWharton_1.png";
import fourSeasonsImg2 from "../../assets/screenshots/4SeasonsWharton/4SeasonsWharton_2.png";
import fourSeasonsImg3 from "../../assets/screenshots/4SeasonsWharton/4SeasonsWharton_3.png";
import fourSeasonsImg4 from "../../assets/screenshots/4SeasonsWharton/4SeasonsWharton_4.png";

import { onNodeVisible } from "../../utils/elementUtils";
import { LogEvent } from "../../utils/EventLogging";

function Projects(props) {
  useEffect(() => {
    // Schedule observers after paint
    setTimeout(() => {
      document.querySelectorAll('#projects .animate-on-scroll').forEach((el) => {
        onNodeVisible(el, () => {
          el.classList.add('in-view');
        }, 0.1);
      });
      setNavProjects();
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setAllInactive() {
    document.querySelectorAll("a.active").forEach((link) => {
      link.classList.remove("active");
    });
  }

  function setNavProjects() {
    let header = document.querySelector("#projects");
    if (header) {
      onNodeVisible(
        header,
        () => {
          setAllInactive();
          document.querySelector("#projects-link")?.classList.add("active");
          document.querySelector("#projects-link-mobile")?.classList.add("active");
        },
        window.innerWidth > 750 ? 0.15 : 0.1
      );
    }
  }

  function VisitFileFreak() {
    LogEvent("Visit:FileFreak");
    window.open("https://filefreak.io", "_blank");
  }

  function Visit4Seasons() {
    LogEvent("Visit:4Seasons");
    window.open("https://4seasonswharton.com", "_blank");
  }

  return (
    <section id="projects">
      <section className="projects-container">
        <h2 id="projects-header" className="projects-header animate-on-scroll">
          Featured Projects
        </h2>

        <section className="projects-grid">

          <div className="animate-on-scroll" style={{ width: '100%' }}>
            <ProjectShowcase
              id="p1"
              projectName="FileFreak.io"
              images={[fileFreakImg, fileFreakImg1, fileFreakImg2, fileFreakImg3, fileFreakImg4]}
              description="FileFreak.io is a modern cloud storage platform designed for both individuals and developers, facilitating secure file storage, access, and sharing. It features a user-friendly dashboard, developer-friendly APIs for programmatic management, and emphasizes security through enterprise-grade encryption, robust access controls, and optional two-factor authentication. Users can easily generate public, password-protected, or expiring links for seamless collaboration."
              links={[
                {
                  text: "Visit FileFreak.io",
                  onClick: VisitFileFreak,
                }
              ]}
              initialLoad={props.initialLoad}
              reverse={false}
            />
          </div>

          <div className="animate-on-scroll" style={{ width: '100%' }}>
            <ProjectShowcase
              id="p2"
              projectName="4 Seasons Wharton"
              images={[fourSeasonsImg, fourSeasonsImg1, fourSeasonsImg2, fourSeasonsImg3, fourSeasonsImg4]}
              description="4 Seasons Mediterranean is a fine dining and event venue located in Wharton, NJ. The restaurant is passionate about bringing the best seasonal flavors from the Riviera and Coastal regions of Italy, Spain, and the South of France. Offering both indoor and beautiful outdoor patio dining, 4 Seasons provides an unforgettable culinary experience with handcrafted cocktails, fine wines, and authentic Mediterranean cuisine."
              links={[
                {
                  text: "Visit 4SeasonsWharton.com",
                  onClick: Visit4Seasons,
                }
              ]}
              initialLoad={props.initialLoad}
              reverse={true}
            />
          </div>

        </section>
      </section>
    </section>
  );
}

export default Projects;
